import { vaultsContractConfig } from "@config/contractsConfig";
import useDappConfig from "@hooks/useDappConfig";
import useVaultClaims from "../hooks/useVaultClaims";
import vaultJson from "@abi/vault/eth.json";

/**
 * Hook for agETH (Airdrop Vault) claims
 * Uses the eth vault contract and configuration
 */
const useAgEthClaims = () => {
  const { vaultEnabledChains } = useDappConfig();

  return useVaultClaims({
    contractConfig: vaultsContractConfig,
    abi: vaultJson,
    enabledChains: vaultEnabledChains,
    pathPatterns: ["/airdrop-gain", "/gain/ageth"],
  });
};

export default useAgEthClaims;
